import React from 'react';
import {
  Create,
  TextInput,
  required,
  minLength,
  maxLength,
  TabbedForm,
  FormTab,
} from 'react-admin';
import { Alert } from '@mui/material';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const CreateCustomerGroup = (props) => {
  return (
    <Permission permission={PERMISSIONS.CUSTOMER_GROUPS}>
      <Create {...props} title='Criar grupo de clientes'>
        <TabbedForm>
          <FormTab label="Identificação">
            <Alert severity="info" sx={{ mb: 2, maxWidth: 620 }}>
              ✨ <strong>Novidade: agora usamos Etiquetas.</strong> Os grupos deram lugar às etiquetas — mais
              flexíveis, porque um mesmo cliente pode ter <strong>várias</strong> etiquetas (antes era só um
              grupo). Crie e gerencie tudo em <strong>Etiquetas</strong>.
            </Alert>
            <TextInput source="name" label="Nome" validate={[required(), minLength(3), maxLength(240)]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
            <TextInput source="description" label="Descrição" validate={[required(), minLength(3), maxLength(240)]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          </FormTab>
        </TabbedForm>
      </Create>
    </Permission>
  );
};

export default CreateCustomerGroup;